import React from 'react'

const EtAdminEvents = () => {
  return (
    <div>EtAdminEvents</div>
  )
}

export default EtAdminEvents